<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      textColor: 'white',
      bgColor: 'primary',
      icon: 'fad fa-circle-info',
    }"
    size="sm"
  >
    <template #body>
      <QList>
        <QItem>
          <QItemSection avatar>
            <QIcon color="primary" name="fad fa-euro-sign" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <h4>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY") }}</h4>
            </QItemLabel>
            <QItemLabel caption>
              {{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY_SUBTITLE") }}
            </QItemLabel>
          </QItemSection>
        </QItem>

        <QItem>
          <QItemSection avatar>
            <QIcon color="primary" name="fad fa-umbrella-simple" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <h4>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_INSURANCE") }}</h4>
            </QItemLabel>
            <QItemLabel caption>
              {{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_INSURANCE_SUBTITLE") }}
            </QItemLabel>
          </QItemSection>
        </QItem>

        <QItem>
          <QItemSection avatar>
            <QIcon color="primary" name="fad fa-arrows-rotate" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <h4>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE") }}</h4>
            </QItemLabel>
            <QItemLabel caption>
              {{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE_SUBTITLE") }}
            </QItemLabel>
          </QItemSection>
        </QItem>

        <QItem>
          <QItemSection avatar>
            <QIcon color="primary" name="fad fa-file-invoice" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <h4>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT") }}</h4>
            </QItemLabel>
            <QItemLabel caption>
              {{ $t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT_SUBTITLE") }}
            </QItemLabel>
          </QItemSection>
        </QItem>
      </QList>
    </template>
    <template #footer>
      <section class="row justify-center">
        <QBtn v-close-popup color="secondary" no-caps class="q-px-lg" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_ACTION')" />
      </section>
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";
  import { StatusBar } from "@core/plugins/mobile";

  let statusbarDelay;

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
    watch: {
      opened(value) {
        if (value === true) {
          // since the modal appears after an animation, we need to match the time of animation before changing color
          statusbarDelay = setTimeout(() => {
            StatusBar.setWhiteBackground();
          }, 50);
        } else {
          // we put back the pricing style
          StatusBar.setBlackBackground();
        }
      },
    },
    unmounted() {
      clearTimeout(statusbarDelay);
    },
  };
</script>
